define(
    'BTM.BRHiddenComponent.BRHiddenComponent', [
        'BTM.BRHiddenComponent.BRHiddenComponent.View',
        'SC.Configuration',
        'Cart.Summary.View',
        'Footer.View',
        'ProductReviews.Center.View',
        'Product.Model',
        'Item.Model',
        'ProductDetailToQuote.View',
        'Header.View',
        'Utils',
        'GlobalViews.StarRating.View'
    ],
    function (
        BRHiddenComponentView, Configuration, CartSummaryView, FooterView, ProductReviewsCenterView, ProductModel, ItemModel, ProductDetailToQuoteView, HeaderView, Utils, GlobalViewsStarRatingView
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                // using the 'Layout' component we add a new child view inside the 'Header' existing view
                // (there will be a DOM element with the HTML attribute data-view="Header.Logo")
                // more documentation of the Extensibility API in
                // https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

                var layout = container.getComponent('Layout');

                // Hide Promotion Area
                var hidePromocodeForm = Configuration.get('brHiddenComponent.hidePromocodeForm');
                CartSummaryView.prototype.getContext = _.wrap(CartSummaryView.prototype.getContext, function (fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    context.hidePromocodeForm = hidePromocodeForm;
                    return context;
                });

                // Hide News Letter Form
                var hideNewsLetterForm = Configuration.get('brHiddenComponent.hideNewsLetterForm');
                FooterView.prototype.getContext = _.wrap(FooterView.prototype.getContext, function (fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    context.hideNewsLetterForm = hideNewsLetterForm;
                    return context;
                });

                // Hide Product Reviews Center
                var hideProductReviewCenter = Configuration.get('brHiddenComponent.hideProductReviewCenter');
                ProductReviewsCenterView.prototype.getContext = _.wrap(ProductReviewsCenterView.prototype.getContext, function (fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    context.hideProductReviewCenter = hideProductReviewCenter;
                    return context;
                });
                GlobalViewsStarRatingView.prototype.getContext = _.wrap(GlobalViewsStarRatingView.prototype.getContext, function (fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    context.hideProductReviewCenter = hideProductReviewCenter;
                    return context;
                });

                // Hide Quotation
                var hideQuotation = Configuration.get('brHiddenComponent.hideQuotation');
                ProductDetailToQuoteView.prototype.getContext = _.wrap(ProductDetailToQuoteView.prototype.getContext, function (fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    context.hideQuotation = hideQuotation;
                    return context;
                });
                HeaderView.prototype.getContext = _.wrap(HeaderView.prototype.getContext, function (fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    context.hideRequestQuoteWizardHeaderLink = hideQuotation;
                    return context;
                });

                var hideCategoryCells = Configuration.get('brHiddenComponent.hideCategoryCells');
                if (hideCategoryCells) {
                    layout.removeChildView('Facets.CategoryCells');
                }

                //Hide Item quantity available
                var hideQuantityAvailable = Configuration.get('brHiddenComponent.hideQuantityAvailable');
                Configuration.itemKeyMapping = Configuration.itemKeyMapping || {};
                _.extend(Configuration.itemKeyMapping, {
                    _showQuantityAvailable: function _showQuantityAvailable() {
                        return hideQuantityAvailable != true;
                    }
                });
            }
        };
    });
